/* @ngInject */
const data = () => {
  const self = {}

  self.mySearchedWagons = []
  self.mySelectedWagons = []
  self.myWagonIds = []
  self.mySelectedIds = []
  self.mySelectedLength = 0

  return self
}

export default data



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/data.service.js